/* ChronoVault social-proof toasts — real Judge.me reviews + real sold-out styles.
   Vanilla JS, no external requests (data ships as a theme asset). */
(function () {
  'use strict';

  var script = document.currentScript;
  var DATA_URL = script && script.dataset.cvspSrc;
  if (!DATA_URL) return;

  var CAT = (script && script.dataset.cvspCat) || 'all';
  var STATE_KEY = 'cvsp_state_v3_' + CAT; // v2: pool rebuilt (named max 2 + Verified Buyer fill), old queues invalid
  var FIRST_DELAY = 8000;          // first toast ~8s after landing
  var MIN_GAP = 20000;             // then one every 20-30s
  var GAP_JITTER = 10000;
  var SHOW_FOR = 8000;             // visible duration

  function loadState() {
    try {
      var raw = sessionStorage.getItem(STATE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) { /* private mode etc. */ }
    return null;
  }

  function saveState(state) {
    try { sessionStorage.setItem(STATE_KEY, JSON.stringify(state)); } catch (e) { /* noop */ }
  }

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  function reviewName(data, entry) {
    var review = data.reviews[entry[1]];
    return review ? (review.name || '').toLowerCase() : '';
  }

  /* Guard: the same reviewer never appears twice in a row in the rotation.
     Greedy swap pass — strict for named reviewers; best-effort for the shared
     "Verified Buyer" label (different anonymous reviewers, so repeats are allowed
     when no alternative exists). */
  function separateSameNames(reviews, data) {
    for (var i = 1; i < reviews.length; i++) {
      if (reviewName(data, reviews[i]) !== reviewName(data, reviews[i - 1])) continue;
      for (var j = i + 1; j < reviews.length; j++) {
        if (reviewName(data, reviews[j]) !== reviewName(data, reviews[i - 1])) {
          var t = reviews[i]; reviews[i] = reviews[j]; reviews[j] = t;
          break;
        }
      }
    }
    return reviews;
  }

  /* Page-category match (owner 2026-10-26): every page only shows reviews / sold-out items
     from its own collection — women's watch pages show women's watch reviews, etc. */
  function matches(item) {
    var c = item.cat || 'all';
    if (CAT === 'all') return true;
    if (CAT === 'watches') return c.indexOf('watches') === 0;
    return c === CAT;
  }

  function picks(list, kind) {
    var out = [];
    list.forEach(function (item, i) { if (matches(item)) out.push([kind, i]); });
    return out;
  }

  function buildQueue(data) {
    var reviews = separateSameNames(shuffle(picks(data.reviews, 'r')), data);
    var sold = shuffle(picks(data.sold_out, 's'));
    var queue = [];
    var max = Math.max(reviews.length, sold.length);
    for (var i = 0; i < max; i++) {
      if (i < reviews.length) queue.push(reviews[i]);
      if (i < sold.length) queue.push(sold[i]);
    }
    return queue;
  }

  var container = null;
  function getContainer() {
    if (!container) {
      container = document.createElement('div');
      container.className = 'cvsp-container';
      container.setAttribute('aria-live', 'polite');
      document.body.appendChild(container);
    }
    return container;
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function renderReview(review) {
    var toast = el('div', 'cvsp-toast');
    var row = el('div', 'cvsp-row');
    row.appendChild(el('div', 'cvsp-avatar', (review.name || '?').charAt(0)));

    var body = el('div', 'cvsp-body');
    var stars = '';
    for (var i = 0; i < 5; i++) stars += i < review.rating ? '★' : '☆';
    body.appendChild(el('div', 'cvsp-stars', stars));
    body.appendChild(el('div', 'cvsp-label', 'Customer review'));
    body.appendChild(el('p', 'cvsp-quote', '“' + review.quote + '”'));
    body.appendChild(el('div', 'cvsp-name', review.name));

    var link = el('a', 'cvsp-product', review.product_title);
    link.href = review.product_url;
    body.appendChild(link);

    row.appendChild(body);
    toast.appendChild(row);
    return toast;
  }

  function renderSoldOut(item) {
    var toast = el('div', 'cvsp-toast');
    var wrap = el('a', 'cvsp-link-wrap');
    wrap.href = item.url;

    var row = el('div', 'cvsp-row');
    var img = el('img', 'cvsp-thumb');
    img.src = item.image;
    img.alt = item.title;
    img.loading = 'lazy';
    row.appendChild(img);

    var body = el('div', 'cvsp-body');
    var label = el('div', 'cvsp-label cvsp-label--soldout');
    label.appendChild(el('span', 'cvsp-dot'));
    label.appendChild(document.createTextNode('Sold out'));
    body.appendChild(label);
    body.appendChild(el('p', 'cvsp-title', item.title));
    body.appendChild(el('p', 'cvsp-sub', 'This style went quickly.'));

    row.appendChild(body);
    wrap.appendChild(row);
    toast.appendChild(wrap);
    return toast;
  }

  function showToast(toast, onDone) {
    var host = getContainer();
    host.innerHTML = '';

    var close = el('button', 'cvsp-close', '×');
    close.setAttribute('aria-label', 'Dismiss notification');
    toast.appendChild(close);
    host.appendChild(toast);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    });

    var hideTimer = setTimeout(hide, SHOW_FOR);

    function hide() {
      clearTimeout(hideTimer);
      toast.classList.add('is-leaving');
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
        onDone();
      }, 380);
    }

    close.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      hide();
    });
  }

  function start(data) {
    if (!data || !Array.isArray(data.reviews) || !Array.isArray(data.sold_out)) return;
    if (!picks(data.reviews, 'r').length && !picks(data.sold_out, 's').length) return;

    var state = loadState();
    if (!state || !Array.isArray(state.queue) || !state.queue.length) {
      state = { queue: buildQueue(data), pos: 0, nextAt: Date.now() + FIRST_DELAY };
      saveState(state);
    }

    function scheduleNext() {
      var delay = Math.max(600, state.nextAt - Date.now());
      setTimeout(tick, delay);
    }

    function tick() {
      if (document.hidden) {
        setTimeout(tick, 5000);
        return;
      }

      if (state.pos >= state.queue.length) {
        state.queue = buildQueue(data);
        state.pos = 0;
      }

      var entry = state.queue[state.pos];
      var toast = null;
      if (entry[0] === 'r' && data.reviews[entry[1]]) {
        toast = renderReview(data.reviews[entry[1]]);
      } else if (entry[0] === 's' && data.sold_out[entry[1]]) {
        toast = renderSoldOut(data.sold_out[entry[1]]);
      }

      state.pos += 1;
      state.nextAt = Date.now() + SHOW_FOR + MIN_GAP + Math.random() * GAP_JITTER;
      saveState(state);

      if (toast) {
        showToast(toast, scheduleNext);
      } else {
        scheduleNext();
      }
    }

    scheduleNext();
  }

  function init() {
    fetch(DATA_URL)
      .then(function (response) { return response.json(); })
      .then(start)
      .catch(function () { /* silently skip if data asset unavailable */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
